import { SubscriptionOptions, TypedUseInfiniteQuery } from '@reduxjs/toolkit/dist/query/react';
import { useRef } from 'react';
import useInfiniteQuery from 'src/app/hooks/useInfiniteQuery';
import { useVT } from 'virtualizedtableforantd4';

const useVirtualizedTable = <T>({
  queryFn,
  args,
  options,
  tableHeight,
  selector = 'rows',
}: {
  queryFn: TypedUseInfiniteQuery<any, any, any, any>;
  args?: any;
  options?: SubscriptionOptions & {
    skip?: boolean | undefined;
    refetchOnMountOrArgChange?: number | boolean | undefined;
    initialPageParam?: any;
  };
  tableHeight: number | string;
  rowHeight?: number;
  selector?: string;
}) => {
  const tableRef = useRef<any>();
  const response = useInfiniteQuery<T>({ args, queryFn, options, selector });

  const handleNextPage = async () => {
    await response.fetchNextPage();
  };

  //   const handlePreviousPage = async () => {
  //     await response.fetchPreviousPage();
  //   };

  // Vt component to be able to trigger queries on scroll in antd table
  const [vt, , ref] = useVT(
    () => ({
      onScroll: ({ isEnd, top }) => {
        // if (top < 50 && !response.isFetchingPreviousPage) {
        //   handlePreviousPage();
        // }
        if (isEnd && !response.isFetchingNextPage) {
          // Get next page
          handleNextPage();
        }
      },
      scroll: {
        y: tableHeight,
      },
      offset: 80,
    }),
    [response.isFetchingPreviousPage, response.isFetchingNextPage, response.fetchNextPage],
  );

  return { ...response, vt, ref, tableRef };
};

export default useVirtualizedTable;
